import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { fetchTransactionById } from "@/services/transactionsApi";
import { useBusiness } from "@hooks/useBusiness";

export default function useTransactionDetails() {
  const { id } = useParams();
  const { businessId, users } = useBusiness();

  const {
    data: transaction,
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: ["transaction", businessId, id],
    queryFn: () => fetchTransactionById(businessId, id, users),
    enabled: Boolean(id && businessId),
    staleTime: 1000 * 60 * 5,
  });

  return { transaction, isLoading, isError, refetch };
}
